var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;opacity:0;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24_Add_Message",
    "data-name": "24_Add Message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18,
    y1: 16,
    x2: 18,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20,
    y1: 18,
    x2: 16,
    y2: 18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18,
    cy: 18,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.2,19.37c-.62,0-.81,2.65-2,2.65S6.8,20.35,5.85,19.37s-1.28-.67-2.3-1.07c-1.4-.55-1.91-1.8-2.22-3.84S.49,4.43,2.56,3.07c2.4-1.58,13.87-1,16-.69S22.66,4,22.93,6.69c.06.56.05,7.39.05,3.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.93,10.34A1.21,1.21,0,0,1,18,10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.15,10.2c-.5.91.6,1.15.84.69C7.49,9.91,6.33,9.87,6.15,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.57,10.2c-.5.91.61,1.15.84.69C12.91,9.91,11.75,9.87,11.57,10.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMessage);
export default __webpack_public_path__ + "static/media/add_message.8f9642f0a7427fdfe9d4d5c7dbb52551.svg";
export { ForwardRef as ReactComponent };